import gql from 'graphql-tag'

export const ECO_HUB_TECH_USER_DELETE_MUTATION = gql`
    mutation ecoHubTechUserDelete {
        ecoHubTechUserDelete {
            status
        }
    }
`
